// extracted by mini-css-extract-plugin
export default {"section__title":"styles_section__title__EpbtZ","item":"styles_item__MFSf-","item__text":"styles_item__text__X3Xle","item__image":"styles_item__image__BwMZ+"};